import {Header} from '@mds/mds-reactjs-library'
import {useContext} from 'react'
import {useIntl} from 'react-intl'
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom'

import OrganizationContext from '../../../context/OrganizationContext'
import HeaderLogo from '../header-logo'
import HeaderRightSection from '../header-right-section'

import style from './HeaderMenu.module.css'
import {
  createOrganizationOrganizationIdNavConfig,
  createOrganizationsNavConfig,
  GeneratorContext
} from './MenuGenerators'

type NavConfig = {label: string; locator: () => boolean; onClick: () => void}[]

type CatalystZeroHeaderParams = {
  generator: (generatorContext: GeneratorContext) => NavConfig
}

const CatalystZeroHeader = ({generator}: CatalystZeroHeaderParams) => {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  const {organization} = useContext(OrganizationContext)

  return (
    <Header
      className={style.headerMenu}
      logoSection={<HeaderLogo />}
      navConfig={generator({intl, location, navigate, organization})}
      rightSection={HeaderRightSection}
    />
  )
}

const noOrganizationHeader = <CatalystZeroHeader generator={createOrganizationsNavConfig} />

const HeaderMenu = () => {
  return (
    <Routes>
      <Route element={noOrganizationHeader} path="/organizations" />
      <Route element={noOrganizationHeader} path="/factor-library/*" />
      <Route
        element={<CatalystZeroHeader generator={createOrganizationOrganizationIdNavConfig} />}
        path="/organizations/:organizationId/*"
      />
    </Routes>
  )
}

export default HeaderMenu
